import { createApp } from "vue";
import App from "@/src/AppHomepage.vue";
import router from "@/src/router/homepage.js";
import store from "@/src/store";
import mitt from "mitt";
import Antd from "ant-design-vue";
import "@/src/styles/_app.css";
import { useCSVBoxState } from "@/src/utils/csvBoxState.js";
import ThemeImage from "@/src/components/ThemeImage.vue";
import themeAwareImage from "@/src/directives/themeAwareImage.js";

const emitter = mitt();
const app = createApp(App);

const csvBoxState = useCSVBoxState();
app.provide("csvBoxState", csvBoxState);

app.use(router);
app.use(store);
app.use(Antd);
app.config.globalProperties.emitter = emitter;
app.component("ThemeImage", ThemeImage);
app.directive("theme-image", themeAwareImage);

app.mount("#app_homepage");
